module.exports = __webpack_public_path__ + "static/media/lobby.674dd02b.mp3";